"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const general_1 = require("../../assets/jss/general");
const styles = (theme) => (0, styles_1.createStyles)({
    root: Object.assign(Object.assign({}, general_1.container), { display: 'flex', flex: 1, flexDirection: 'column' }),
    centered: {
        display: 'flex',
        justifyContent: 'center'
    },
    gameHeader: {
        marginTop: theme.spacing(4)
    },
    detailContainer: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    },
    detailContainerCard: {
        padding: 0,
        width: 350,
        height: 350
    },
    detailCardWrapper: {
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            paddingRight: 0,
            paddingBottom: theme.spacing(4)
        }
    },
    howToPlay: {
        marginTop: theme.spacing(5),
        flexDirection: 'column'
    },
    tabs: {
        paddingTop: theme.spacing(4)
    },
    table: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(4)
    },
    relatedGames: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: theme.spacing(2)
    },
    relatedGameTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginTop: theme.spacing(2)
    },
    drawsData: {
        borderRadius: 4,
        marginBottom: theme.spacing(),
        overflow: 'hidden'
    },
    column: {
        flexBasis: '25%',
        [theme.breakpoints.down('md')]: {
            flexBasis: '33.33%'
        },
        [theme.breakpoints.down('xs')]: {
            flexBasis: '50%'
        }
    },
    panelDetails: {
        backgroundColor: theme.palette.grey[100],
        paddingTop: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            flexFlow: 'row wrap'
        }
    },
    heading: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        height: 60,
        marginTop: theme.spacing(2)
    },
    drawName: {
        maxWidth: 245,
        [theme.breakpoints.down('lg')]: {
            maxWidth: 215
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: 210
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: 300
        }
    },
    drawPrize: {
        maxWidth: 255,
        [theme.breakpoints.down('lg')]: {
            maxWidth: 210
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: 200
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: 330
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: 288
        }
    },
    triangle: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        display: 'block',
        borderRight: '30px solid transparent',
        borderBottom: '30px solid transparent',
        borderTop: '30px solid',
        borderTopColor: theme.palette.primary.main
    },
    triangleIcon: {
        color: theme.palette.primary.contrastText,
        position: 'absolute',
        top: -30,
        fontSize: 18
    },
    noDrawsContainer: {
        display: 'flex',
        margin: 40,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: theme.spacing(6)
    },
    noDrawsIcon: {
        fontSize: 64,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2)
    },
    drawNameColumn: {
        [theme.breakpoints.down('xs')]: {
            flexBasis: '100%'
        }
    },
    topPrize: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
            flex: '1 100%'
        }
    },
    innerColumn: {
        marginRight: theme.spacing(4),
        [theme.breakpoints.down('lg')]: {
            marginRight: theme.spacing(3)
        },
        [theme.breakpoints.down('xs')]: {
            flex: '1 43%',
            marginRight: theme.spacing(2),
            marginTop: theme.spacing(2)
        }
    },
    buttonColumn: {
        alignSelf: 'center',
        [theme.breakpoints.down('xs')]: {
            flex: '1 100%',
            marginTop: theme.spacing(2)
        }
    },
    drawButton: {
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    noMargin: {
        [theme.breakpoints.down('xs')]: {
            marginRight: 0
        }
    },
    above: {
        zIndex: 1
    }
});
exports.default = styles;
//# sourceMappingURL=DrawsTableStyle.js.map